export default __webpack_public_path__ + "static/media/eco1.096d0050.jpg";